import type { Testimonial } from '@/types/content'

/**
 * Client quotes.
 *
 * Deliberately empty. The template shipped four invented testimonials
 * attributed to named people; publishing those on a real portfolio would be
 * presenting fabricated endorsements as genuine. Add real ones — with the
 * person's permission — and every surface that reads this will light up
 * again on its own.
 */
export const testimonials: readonly Testimonial[] = []
